import React from 'react';
import {Tab, TabPanel, Tabs, TabList} from 'react-tabs';
import {Editor} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Spinner from '../spinner/spinner';
import StageEditor from '../stage-editor/stage-editor';
import HallMetadata from './hall-metadata';
import HallBooths from './hall-booths';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import './hall-editor.css';

/** @class HallEditor
  * A component for editing a hall in a virutal expo.
  */
export default class HallEditor extends ReactFireComponent {
  /** @constructor
    * Creates a new instance of a HallEditor
    */
  constructor(props){
    super(props);
    const expoID = props.match.params.expoID;
    const showID = props.match.params.showID;
    const hallID = props.match.params.hallID;
    this.state = {
      expoID: expoID,
      showID: showID,
      hallID: hallID
    }
    this.hallURL = `/expos/${expoID}/shows/${showID}/halls/${hallID}`;
    this.boothURL = `/expos/${expoID}/shows/${showID}/booths`;
  }
  /** @method componentWillMount
    * Binds the component to the corresponding firebase
    * hall record.
    */
  componentWillMount() {
    this.bindAsObject(this.hallURL, 'hall');
    //this.bindAsArray(this.boothURL, 'booths');
  }
  /** @method componentWillUnmount
    * Unbinds the component from firebase.
    */
  componentWillUnmount() {
    this.unbind('hall');
    //this.unbind('booths');
  }
  /** @function render
    * Renders the component.
    */
  render() {
    if(!this.state.hall) return <Spinner/>
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Properties</Tab>
            <Tab>Stage</Tab>
            <Tab>Booths</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <HallMetadata {...this.state.hall}
              dataURL={this.hallURL}/>
          </TabPanel>
          <TabPanel>
            <StageEditor {...this.state.hall.stage}
              dataURL={this.hallURL + '/stage'}/>
          </TabPanel>
          <TabPanel>
            <HallBooths {...this.state.hall}
              hallID={this.state.hallID}
              name={this.state.hall.name}
              stage={this.state.hall.stage}
              booths={this.state.hall.booths || {} }
              hallURL={this.hallURL}
              boothURL={this.boothURL}/>
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/hall/${this.state.hallID}`} />
          </TabPanel>
        </Tabs>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/hall-editor/hall-editor.js